import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useUser } from '@state/uses/users'
import { useHistory, useLocation } from 'react-router-dom'
import UserButton from '@components/UserButton'
import MobileNavigation from '@components/MobileNavigation'
import i18n from '@localization/i18n'
import urlUtils from '@services/urlUtils'

export default ({}) => {
    const dancesHE = i18n.t('headers.dances')
    const myDancesHE = i18n.t('headers.my_dances')
    const usersHE = i18n.t('headers.users')
    const settingsHE = i18n.t('headers.settings')
    const user = useUser()
    const history = useHistory()
    const location = useLocation()
    const [fakeLinkSelected, setFakeLinkSelected] = useState(null)
    useEffect(() => {
        if (location.pathname === '/index.html') {
            history.push('/')
        }
    }, [])

    return (
        <HeaderNav>
            <UserPart onClick={() => setFakeLinkSelected(null)}>
                <UserButton />
            </UserPart>
            <MobileNavigation />
            <DesktopNavUl>
                {user && (
                    <div>
                        <Tab
                            fakeLinkSelected={fakeLinkSelected === dancesHE}
                            onClick={() => {
                                setFakeLinkSelected(dancesHE)
                                urlUtils.goToDances(history, user)
                            }}>
                            <Link to="/dances">{dancesHE}</Link>
                        </Tab>
                        <Tab
                            fakeLinkSelected={fakeLinkSelected === myDancesHE}
                            onClick={() => {
                                setFakeLinkSelected(myDancesHE)
                                urlUtils.goToMyDances(history, user)
                            }}>
                            <div className="fake-link">{myDancesHE}</div>
                        </Tab>
                    </div>
                )}
                {user && user.is_admin && (
                    <div>
                        <Tab
                            fakeLinkSelected={fakeLinkSelected === usersHE}
                            onClick={() => setFakeLinkSelected(usersHE)}>
                            <Link to="/users">{usersHE}</Link>
                        </Tab>
                        <Tab
                            fakeLinkSelected={fakeLinkSelected === settingsHE}
                            onClick={() => setFakeLinkSelected(settingsHE)}>
                            <Link to="/settings">{settingsHE}</Link>
                        </Tab>
                    </div>
                )}
            </DesktopNavUl>
        </HeaderNav>
    )
}

const HeaderNav = styled.nav`
    display: flex;
    font-size: 16px;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-between;
    background-color: rgb(83, 71, 103);
`

const DesktopNavUl = styled.ul`
    margin: 0;
    display: flex;
    padding: 5px;
    font-size: 15px;
    @media (max-width: 768px) {
        display: none;
    }
`

const Tab = styled.li`
    list-style-type: none;
    display: inline-flex;
    flex-direction: row;
    /* width:50px; */
    margin: 10px;
    justify-content: space-between;
    color: #ffffff;
    text-align: center;
    & a,
    & .fake-link {
        color: #fff;
        color: ${(p) => (!p.fakeLinkSelected ? '#fff' : '#007bff')};
        text-decoration: none;
        text-decoration: ${(p) => (!p.fakeLinkSelected ? 'none' : 'underline')};
        cursor: pointer;
    }
    & a:hover,
    & .fake-link:hover {
        color: #007bff;
        text-decoration: none;
    }
    & a:focus,
    & .fake-link:focus {
        outline: none !important;
    }

    & button {
        background-color: transparent;
        border: none;
        cursor: pointer;
        width: 30px;
        color: #ffffff;
        font-family: 'Arial';
        display: inline-flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    & img {
        width: 15px;
        height: auto;
    }
    & span {
        margin: 0px 8px;
        font-size: 15px;
        border: 1px solid #ffffff;
        padding: 5px;
    }
`
const UserPart = styled.div`
    display: flex;
    margin-right: 0 20px;
    flex-direction: row;
`
